module.exports = __webpack_public_path__ + "static/hero-team-bd2037fb505ebd178559cd070530db76.svg";